import type { SessionTutorialDemoLine, SessionTutorialMode } from '@/features/session-tutorial/sessionTutorial.types';

/** Pause between sample lines, in ms: slow enough to read, short enough not to bore. */
export const DEMO_LINE_INTERVAL_MS = 1_600;

/** How long the "talrit mun birtast hér" hint shows before the first sample line, in ms. */
export const DEMO_LEAD_IN_MS = 3_500;

/** Time to look at the finished transcript before the tour moves on to making the note, in ms. */
export const DEMO_SETTLE_MS = 2_000;

/** Fictional consultation (the onboarding sample's low back pain); no real person or patient data. */
export const sessionTutorialDemoScript: Record<SessionTutorialMode, SessionTutorialDemoLine[]> = {
  conversation: [
    { speaker: 'doctor', text: 'Góðan daginn, hvað get ég gert fyrir þig í dag?' },
    { speaker: 'patient', text: 'Ég hef verið með verk í mjóbakinu í um tvær vikur, síðan ég var að flytja.' },
    { speaker: 'doctor', text: 'Leiðir verkurinn niður í fæturna?' },
    {
      speaker: 'patient',
      text: 'Nei, hann er bara í bakinu. Hann versnar þegar ég sit lengi en skánar þegar ég geng.',
    },
    {
      speaker: 'doctor',
      text: 'Hversu slæmur er hann á skalanum núll til tíu? Og hefur þú verið með hita eða átt erfitt með þvaglát?',
    },
    { speaker: 'patient', text: 'Svona sex. Enginn hiti og þvaglátin eru eðlileg.' },
    { speaker: 'doctor', text: 'Ég finn eymsli yfir neðstu liðum hægra megin, en taugaskoðun er eðlileg.' },
    { speaker: 'doctor', text: 'Prófum kjarnaæfingar og hita, og hittumst aftur eftir tvær vikur.' },
  ],
  dictation: [
    { speaker: 'doctor', text: 'Mjóbaksverkur í tvær vikur eftir flutninga, leiðir ekki niður í fætur.' },
    { speaker: 'doctor', text: 'Versnar við langa setu, skánar við göngu. Verkur sex af tíu.' },
    { speaker: 'doctor', text: 'Enginn hiti, eðlileg þvaglát, ekkert þyngdartap.' },
    { speaker: 'doctor', text: 'Skoðun: eymsli yfir L4 til L5 hægra megin, SLR neikvætt, eðlileg taugaskoðun.' },
    { speaker: 'doctor', text: 'Áætlun: kjarna- og teygjuæfingar, hiti eftir þörfum, endurmat eftir tvær vikur.' },
  ],
};
